var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMillustrationsOkta = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 40,
  fill: "none",
  viewBox: "0 0 56 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 23,
  x: 8.5,
  y: 8.5,
  fill: "#fff",
  stroke: "#CCCCD9",
  rx: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8A8A99",
  fillRule: "evenodd",
  d: "M26.12 21.02a.155.155 0 0 0-.265.109h-.004v1.018c0 .067-.06.133-.15.133h-.588c-.07 0-.154-.028-.154-.13v-4.43c0-.06.049-.126.15-.126h.588c.067 0 .15.038.15.14v1.998c0 .144.175.214.273.109.276-.294.682-.732.855-.919l.083-.09c.011-.013.029-.027.07-.041q.03-.009.07-.007h.721c.148 0 .19.16.123.245l-1.043 1.165c-.171.182-.189.252-.038.43l.07.07 1.316 1.348c.066.084.024.249-.12.249h-.794q-.05.002-.077-.007a.12.12 0 0 1-.058-.037l-.005-.005-.02-.021c-.12-.127-.754-.796-1.152-1.2M21 20.538a1.76 1.76 0 1 1 3.521 0 1.76 1.76 0 1 1-3.521 0m.878 0a.883.883 0 1 0 1.766-.002.883.883 0 0 0-1.765.002m8.778 1.592-.063-.588a.14.14 0 0 0-.164-.123.882.882 0 0 1-1.015-.823v-.769c0-.095.07-.172.164-.172h.788c.056 0 .14-.049.14-.15v-.557c0-.108-.07-.164-.133-.164h-.795a.164.164 0 0 1-.168-.158v-.892a.14.14 0 0 0-.15-.14h-.585c-.073 0-.143.045-.143.136v2.867a1.76 1.76 0 0 0 1.995 1.694c.084-.01.14-.08.13-.161m3.669-1.586c0 .668.077.847.574.847.06 0 .101.06.101.112v.626c0 .169-.337.166-.433.165h-.015c-.416-.004-.682-.172-.847-.424a1.76 1.76 0 0 1-2.905-1.337 1.76 1.76 0 0 1 2.629-1.53v-.073c0-.09.08-.15.154-.15h.588a.15.15 0 0 1 .154.15v1.614m-2.643-.007c0 .486.396.882.882.882a.887.887 0 0 0 .882-.882.883.883 0 0 0-1.764 0",
  clipRule: "evenodd"
})));
export default SvgMillustrationsOkta;